import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Helmet } from 'react-helmet';
import { useLocation, useMatch, useParams } from 'react-router-dom';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
/**
 * コンポーネント名
 * @description Route に渡すコンポーネントをラップするコンポーネント
 * @deprecated react-router v5 から v6 移行時の暫定対応用のため、新規開発時には使用しない
 */
export const WrapRouteContent = (props) => {
    const { component: Component, description, title } = props;
    const location = useLocation();
    const params = useParams();
    const match = useMatch(location.pathname);
    const parametrizedHistory = useNavigate();
    const parametrizedMatch = match
        ? { params, url: match.pathname }
        : null;
    return (_jsxs(_Fragment, { children: [(title || description) && (_jsxs(Helmet, { children: [title && _jsx("title", { children: title }), description && _jsx("meta", { content: description, name: 'description' })] })), Component ? (_jsx(Component, { history: parametrizedHistory, location: location, match: parametrizedMatch })) : null] }));
};
